const styles = {
  dialogPaper: {
    borderRadius: "12px",
    maxWidth: "556px",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: "14px 24px",
    borderBottom: "1px solid #EAEAEA",
  },
  title: {
    fontWeight: "600",
    color: "rgba(47, 43, 61, 0.9)",
    lineHeight: "28px",
    fontSize: "18px",
  },
  closeButton: {
    mr: "-10px",
  },
  closeIcon: {
    color: "rgba(62, 63, 76, 1)",
    fontSize: "24px",
  },
  dialogContent: {
    p: "24px",
  },
  heading: {
    mb: "16px",
    fontSize: "18px",
    fontWeight: 500,
    color: "rgba(47, 43, 61, 0.9)",
  },
  description: {
    fontSize: "15px",
    color: "rgba(47, 43, 61, 0.9)",
  },
  activeOrdersStyles: {
    mt: "24px",
    fontSize: "15px",
    fontWeight: 700,
    color: "rgba(47, 43, 61, 0.9)",
  },
  dialogActions: {
    justifyContent: "space-between",
    gap: "10px",
    flexDirection: { xs: "column", sm: "row" },
    p: "12px 24px",
  },
  cancelButton: {
    backgroundColor: "rgba(128, 131, 144, 1)",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "500",
    color: "white",
    textTransform: "none",
    width: { xs: "100%", sm: "auto" },
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(128, 131, 144, 0.9)",
      boxShadow: "none",
    },
  },
  confirmButton: {
    ml: "0px !important",
    width: { xs: "100%", sm: "auto" },
    textTransform: "none",
    color: "rgba(255, 255, 255, 1)",
    fontWeight: 500,
    fontSize: "15px",
    borderRadius: "8px",
    px: "16px",
    py: "6px",
    backgroundColor: "rgba(183, 72, 74, 1)",
    borderColor: "rgba(183, 72, 74, 1)",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "rgba(183, 72, 74, 0.9)",
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgba(183, 72, 74, 0.4)",
      color: "rgba(255, 255, 255, 0.7)",
    },
  },
  progress: {
    ml: "8px",
  },
};

export default styles;
